export type CatalogItemName = {
  name: string
  alternativeSearchNames?: string[]
}

// Add alternative search names to products to be shown in the catalog.
// e.g. "Bank transfer" is also known as "ACH", so it should also show
// up in the catalog when searching for "ACH".
const itemNames: CatalogItemName[] = [
  {
    name: "Bank Transfer",
    alternativeSearchNames: ["ACH"],
  },
  {
    name: "Virtual Visa",
    alternativeSearchNames: ["Mastercard"],
  },
  {
    name: "Virtual Visa International",
    alternativeSearchNames: ["Mastercard"],
  },
  {
    name: "Physical Visa",
    alternativeSearchNames: ["Mastercard"],
  },
]

export const searchableItemNames = (name: string): string[] => {
  const item = itemNames.filter(i => i.name === name)[0]
  if (item) {
    return [name, ...(item.alternativeSearchNames || [])]
  }
  return [name]
}
